<template>
  <div id="vue-pagescreate" class="container px-0 mb-4">
    <router-view v-slot="{ Component }">
      <component :is="Component">
        <template #terms>
            <div class="row mx-0">
              <div v-if="pagesCreateStore.state.disclaimerText" class="mb-2">
                <div v-html="pagesCreateStore.state.disclaimerText" class="text-justify text-small"/>
              </div>
              <TermsConditions button-that-agrees-text="Logging in, Registering or Creating a page" />
            </div>
        </template>
      </component>
    </router-view>
    
  </div>
</template>

<script>
import { getCurrentInstance, onBeforeMount, onMounted } from 'vue'
import router from './routes/router.js'
import store from './store/store.js'
import VueScrollTo from 'vue-scrollto'
import useWowJs from './composables/useWowJs'
import { Vue3LoggerPlugin } from '@gf/gf-logger'
import SimpleVueValidation from 'simple-vue3-validator';
import useEmitter from './composables/useEmitter'
import useBeneficiaryService from './composables/useBeneficiaryService'
import usePagesService from './composables/usePagesService'
import _ from 'lodash'
import TermsConditions from './components/login/TermsConditions.vue'
import useUrlFunctions from './composables/urlFunctions'

export default {
    name: 'GfPagescreate',
    components: { TermsConditions },
    router,
    store,
    props: {
        store: {
            type: Object,
            default: null,
        },
        region: {
            type: String,
            default: '',
        },
        regionId: {
            type: String,
            default: '',
        },
        referrer: {
            type: String,
            default: '',
        },
        captchaPublicKey: {
            type: String,
            default: '',
        },
        beneficiaryId: {
            type: [String, Number],
            default: '',
        },
        eventId: {
            type: [String, Number, Object],
            default: '',
        },
        teamId: {
            type: [String, Number],
            default: '',
        },
        user: {
            type: String,
            default: '',
        },
        externalId: {
            type: String,
            default: '',
        },
        apiDomain: {
            type: String,
            default: 'https://api.au.awstest.gfrnetworks.com',
        },
        pageType: {
            type: String,
            default: '', // team or individual
        },
        activationId: {
            type: String,
            default: '',
        },
        pageId: {
            type: String,
            default: '',
        },
        authProvider: {
            type: Array,
            default: () => [],
        },
        authFacebook: {
            type: Object,
            default: () => ({
                appId: '',
                scope: '',
                state: '',
                redirectUrl: ''
            })
        },
        userName: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const pagesCreateStore = props.store || store;
        const { getQueryParam } = useUrlFunctions();
        let vm = getCurrentInstance().appContext.config.globalProperties;
        const initializePlugins = () => {
            const wow = useWowJs();
            wow();
            getCurrentInstance().appContext.app.use(router);
            getCurrentInstance().appContext.app.use(Vue3LoggerPlugin);
            getCurrentInstance().appContext.app.use(store);
            getCurrentInstance().appContext.app.use(SimpleVueValidation);
            useEmitter().install();
        };
        const getTeamPage = async (teamId) => {
            const pageDetails = await usePagesService().getTeamPage(teamId);
            if (pageDetails !== null) {
                pagesCreateStore.commit('setPageType', 'joinTeam');
                pagesCreateStore.commit('change_jointeam_data', {
                    page: pageDetails,
                    Router_Name: 'select_team',
                });
                vm.$router.push({
                    name: 'complete_jointeam',
                });
            }
            else {
                pagesCreateStore.commit('pre_TeamId', '');
                pagesCreateStore.commit('setPageType', 'individual');
                vm.$router.push('/individual/charity');
            }
        };
        const updateBeneficiaryDetails = details => {
            pagesCreateStore.commit('pre_BeneficiaryId', details);
            pagesCreateStore.commit('change_Beneficiary', {
                beneficiaryId: details.id,
                BeneficiaryName: details.name,
                BeneficiaryImagePath: details.ImagePath,
                Router_Name: 'charity_individual',
            });
        };
        const doBeneficiaryValidityCheck = async () => {
            var res;
            if (props.eventId && props.eventId.id && props.eventId.id != "")
                res = await useBeneficiaryService().getBeneficiaryDetailsForEvent(props.beneficiaryId, props.eventId.id);
            else
                res = await useBeneficiaryService().getBeneficiaryById(props.beneficiaryId);
            if (res.data && res.data.ResultsReturned === 1) {
                var beneficiaryDetails = {
                    id: res.data.Beneficiaries[0].BeneficiaryAccountId,
                    ImagePath: res.data.Beneficiaries[0].BeneficiaryImagePath,
                    name: res.data.Beneficiaries[0].BeneficiaryName,
                };
                updateBeneficiaryDetails(beneficiaryDetails);
            }
            else {
                pagesCreateStore.commit('pre_BeneficiaryId', '');
            }
        };
        const doSingleBeneficiaryCheck = async () => {
            var res = await useBeneficiaryService().searchByEvent(props.eventId.id);
            if (res.data && res.data.ResultsReturned === 1) {
                var beneficiaryDetails = {
                    id: res.data.Beneficiaries[0].BeneficiaryAccountId,
                    ImagePath: res.data.Beneficiaries[0].BeneficiaryImagePath,
                    name: res.data.Beneficiaries[0].BeneficiaryName,
                };
                updateBeneficiaryDetails(beneficiaryDetails);
            }
        };

        const scrollToComponent = () => {
            setTimeout(() => {
                VueScrollTo.scrollTo('#vue-pagescreate', '100', {
                    easing: 'ease-in',
                    offset: -60,
                    force: true,
                });
            }, 1000);
        };

        initializePlugins();
        onBeforeMount(async () => {            
            pagesCreateStore.commit('setApiDomain', props.apiDomain);
            pagesCreateStore.commit('setReferrer', getQueryParam('eidtype') ?? props.referrer);
            if (props.region && props.region.length > 0)
                pagesCreateStore.commit('setRegion', props.region);
            if (props.regionId && props.regionId.length > 0)
                pagesCreateStore.commit('setRegionId', props.regionId);
            pagesCreateStore.commit('setCaptchaKey', props.captchaPublicKey);
            if (props.authProvider && props.authProvider.length > 0)
                pagesCreateStore.commit('setAuthProvider', props.authProvider);
            if (props.authFacebook && !_.isEmpty(props.authFacebook)) {
                if (_.has(props.authFacebook, 'appId') &&
                    _.has(props.authFacebook, 'scope') &&
                    _.has(props.authFacebook, 'redirectUrl')) {
                    pagesCreateStore.commit('setAuthFacebook', props.authFacebook);
                }
                else {
                    vm.$gfLogger.logInfo('Warning: authFacebook requires appId, scope, state and redirectUrl');
                }
            }

            if (props.activationId && props.activationId.length > 0)
                pagesCreateStore.commit('setActivationId', props.activationId);
            if (props.pageId && props.pageId.length > 0)
                pagesCreateStore.commit('setPageId', props.pageId);
        
            if (getQueryParam('tid') || props.teamId && props.teamId != '') {     
                var teamId = getQueryParam('tid') ?? props.teamId;           
                pagesCreateStore.commit("pre_TeamId", teamId);
                await getTeamPage(teamId);
                vm.$gfLogger.logInfo('GfPagescreate.created(), teamId', teamId);
            }
            if (props.beneficiaryId && props.beneficiaryId !== '')
                await doBeneficiaryValidityCheck();
            if (props.eventId && props.eventId.id != '') {
                var noBenIdInDashboard = pagesCreateStore.state.data_params_pre.beneficiaryId === '' &&
                    vm.$router.currentRoute.value.path === '/';
                if (noBenIdInDashboard) {
                    await doSingleBeneficiaryCheck();
                }
                pagesCreateStore.commit('pre_EventId', props.eventId);
                pagesCreateStore.commit('change_event', {
                    EventCampaignId: pagesCreateStore.state.data_params_pre.eventId.id,
                    EventName: pagesCreateStore.state.data_params_pre.eventId.name,
                    EventImagePath: pagesCreateStore.state.data_params_pre.eventId
                        .ImagePath,
                    EventUrl: window.location.origin,
                    Router_Name: 'event_individual',
                });
            }
            if (props.userName != '') {
                vm.$gfLogger.logInfo('setting store.state.userLogon to', props.userName);
                pagesCreateStore.commit('preUserLogin', props.userName);
            }
            if (props.externalId != '') {
                pagesCreateStore.commit('pre_ExternalId', props.externalId);
            }
            if (props.login) {
                pagesCreateStore.commit('pre_Login', props.login);
            }
            vm.$gfLogger.logInfo('GfPagescreate.created(), this.pageType', props.pageType);
            var pageType = getQueryParam('pagetype') ?? props.pageType
            if (pageType) {
                if (pageType.toLowerCase() === 'team' || pageType.toLowerCase() === 't') {
                    vm.$router.push('/team/charity');
                }
                if (pageType.toLowerCase() === 'individual' || pageType.toLowerCase() === 's') {
                    vm.$router.push('/individual/charity');
                }
            }
            pagesCreateStore.commit('appReadyForUserInput');
        });
        onMounted(() => {
            scrollToComponent();
        });

        return {
            pagesCreateStore
        }
    }
}
</script>

<style lang="css">
@import "assets/css/animate.min.css";
@import 'bootstrap/dist/css/bootstrap.css';
@import "assets/css/main.css";
</style>
